module.exports = {"350783001":"建安街道","350783002":"通济街道","350783003":"瓯宁街道","350783004":"芝山街道","350783100":"徐墩镇","350783101":"吉阳镇","350783102":"房道镇","350783103":"南雅镇","350783104":"迪口镇","350783105":"小桥镇","350783106":"玉山镇","350783107":"东游镇","350783108":"东峰镇","350783109":"小松镇","350783200":"顺阳乡","350783201":"水源乡","350783202":"川石乡","350783203":"龙村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350783.json
// module id = 1341
// module chunks = 0